import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// ─────────────────────────────────────────────────────────────
// TODO: Paste your Firebase web app config here.
// Firebase Console → Project Settings → General → Your apps
// ─────────────────────────────────────────────────────────────
const firebaseConfig = {
  apiKey: "AIzaSyC8fIT4wdKBFUSO4BKoaqjnVooKUuGpNhE",
  authDomain: "klaivox-d4a84.firebaseapp.com",
  projectId: "klaivox-d4a84",
  storageBucket: "klaivox-d4a84.firebasestorage.app",
  messagingSenderId: "278286708986",
  appId: "1:278286708986:web:f28a77fc1904a0cb4d9943",
  measurementId: "G-ZZS0GNPZ72"
};

const app = initializeApp(firebaseConfig);

export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);
export default app;
